<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Polis',

    metaInfo: { title: 'Polis' },

    extends: View,

    mixins: [
      LoadSections([
        'policy',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'polistakaful',
      },
    },
  }
</script>
